import { gql, QueryHookOptions, QueryResult } from '@apollo/client';

import { useAPIQuery } from 'Api/handler';

import { User } from 'Types';

type GetViewerResponse = {
  viewer: User;
};

export const useGetViewer = (
  options?: QueryHookOptions<GetViewerResponse>,
): QueryResult<GetViewerResponse> => {
  return useAPIQuery(GET_VIEWER, options);
};

export const GET_VIEWER = gql`
  query GetViewer {
    viewer {
      id
      uuid
      firstName
      lastName
      fullName
      role
      lang
      isActive
    }
  }
`;
